import React, { useContext } from 'react';
import { RecordContext } from '../../../App';
import QueryField from '../../aegeon/query/QueryField';
import TimeseriesField from "../../aegeon/timeseries/TimeseriesField";
import TableSubdevicesComponent from './TableSubdevicesComponent';

const TableSubdevicesCard = (props) => {
  const moment = require('moment');
  const today = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const startDateOneYear = moment().set({ year: moment().year() - 10, month: 0, date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 });
  const filter_one_year = { startDate: startDateOneYear, endDate: today };

  const source = {
    source: 'billed_energy',
    filter: filter_one_year,
    aggregation: { period: 'MONTH', operation: 'SUM' },
  };

  const source_analog = {
    source: 'manual_bills',
    filter: filter_one_year,
    aggregation: undefined
  }

  const { record } = useContext(RecordContext);
  const is_billed_energy_device = ["grdfMeter", "enedisMeter"].includes(record?.deviceType);

  return (
    is_billed_energy_device ?
      <TimeseriesField source={source.source} filter={source.filter} aggregation={source.aggregation}>
        <QueryField query_name="getDeviceSubdevicesTimeseries" params={{ id: record?.id, time: { between: [startDateOneYear, today] } }}>
          <TableSubdevicesComponent setDataSourcesCallback={props.setDataSourcesCallback} record={record} source={source} />
        </QueryField>
      </TimeseriesField>
      :
      <TimeseriesField source={source_analog.source} filter={source_analog.filter} aggregation={source_analog.aggregation}>
        <QueryField query_name="getDeviceSubdevicesTimeseries" params={{ id: record?.id, time: { between: [startDateOneYear, today] } }}>
          <TableSubdevicesComponent setDataSourcesCallback={props.setDataSourcesCallback} record={record} source={source} />
        </QueryField>
      </TimeseriesField>
  )
};

export default TableSubdevicesCard;